export default __webpack_public_path__ + "static/media/aggregate_sl_init.125471e7.png";